const questions = {
  18012: [
    "Climat",
    "Faut-il introduire une taxe sur les billets d’avion?",
    "Greta Thunberg n’était pas encore une star planétaire, et les élections fédérales moins proches qu’aujourd’hui. Le débat avait porté sur l’intérêt pour la Suisse d’instaurer une taxe, qui n’aurait pour effet que de freiner les voyages des petits revenus. Un symbole important pour un des pays qui prend le plus l’avion, avançaient déjà les partisans du texte.",
    {
      type: "Objet du Conseil fédéral",
      date: "10.12.2018",
      object: "17.071",
      vote: 18010
    }
  ],
  13875: [
    "Biodiversité",
    "Le loup doit-il pouvoir être abattu plus facilement?",
    "La protection du loup est un serpent de mer de la politique fédérale. À l’époque, c’est le Valais qui exigeait «que la récréation soit terminée» en demandant de modifier la législation pour que le loup puisse être chassé. Aux dégâts sur les élevages s'opposait la nécessité de préserver la biodiversité en protégeant les grands prédateurs.",
    {
      type: "Initiative cantonale",
      date: "14.9.2016",
      object: "14.320",
      vote: 13875
    }
  ],
  17516: [
    "Politique des drogues",
    "Faut-il mener des études sur le cannabis à usage récréatif?",
    "Il n’était pas question de dépénalisation ou de légalisation du cannabis, mais uniquement de nouvelles études. À ces arguments des partisans, les opposants rétorquaient que les recherches pour l’usage médical sont déjà autorisées. En clair, si le cannabis est considéré comme une drogue, il n’y a pas à étudier son usage récréatif.",
    { type: "Motion", date: "19.9.2018", object: "17.4111", vote: 17516 }
  ],
  13735: [
    "Vision de la société",
    "Les couples homosexuels doivent-ils pouvoir adopter l’enfant de leur partenaire?",
    "Pour les partisans du projet, il s’agissait de faire face à une réalité qui concerne déjà des milliers de familles, et d’assurer une protection juridique à ces enfants. Les opposants fustigeaient une tactique du salami, alors que l'introduction du partenariat pour les couples homosexuels avait été arrachée avec la promesse qu’il n'octroierait pas l’adoption.",
    {
      type: "Objet du Conseil fédéral",
      date: "17.6.2016",
      object: "14.094",
      vote: 13735
    }
  ],
  17218: [
    "Égalité",
    "L’introduction de quotas de femmes dans les conseils d'administration est-il nécessaire?",
    "En pleine actualité sur l’égalité hommes-femmes, les partisans du projet plaidaient pour une pression étatique afin de favoriser l’accès des femmes aux postes à haute-responsabilité, où elles sont largement sous-représentées. Une intervention étatique? Un non-sens pour les tenants d’une économie libérale, qui doit favoriser l’émergence des meilleurs quel que soit le sexe.",
    {
      type: "Objet du Conseil fédéral",
      date: "14.6.2018",
      object: "16.077",
      vote: 17218
    }
  ],
  13349: [
    "Politique familiale",
    "Faut-il mettre en place un congé paternité de deux semaines minimum?",
    "Bien avant la pression de l’initiative populaire qui exige quatre semaines, le National avait voté sur une motion de Martin Candinas (PDC/GR). Deux semaines, un minimum pour les pères, disaient les partisans du projet. Mais déjà trop pour les détracteurs de l’époque, qui pointaient comme aujourd’hui un coût trop élevé pour l’économie et un défi irréalisable pour les PME.",
    {
      type: "Initiative parlementaire",
      date: "10.12.2018",
      object: "14.415",
      vote: 13349
    }
  ],
  17648: [
    "Agriculture",
    "La Suisse doit-elle se passer à terme du glyphosate?",
    "Le glyphosate est un symbole de l’inquiétude liée aux pesticides. Produit très contesté du fait des incertitudes sur son impact sanitaire, ce dernier ne devrait plus avoir sa place en Suisse, plaidaient les partisans du projet. On n’élimine pas un produit sur la base de soupçons, alors que l’utilisation par l’agriculture suisse est modérée, corrigeaient les opposants.",
    { type: "Postulat", date: "26.9.2018", object: "17.4059", vote: 17648 }
  ],
  18606: [
    "Logement",
    "L’État doit-il s’engager pour offrir davantage de logements abordables?",
    "Avec 40% de propriétaires, les Helvètes restent un peuple de locataires. Les autorités doivent-elles mettre les régies sous tutelle afin d’assurer une part de logements abordables? Ou est-ce une intervention inacceptable de l’État dans la marche des affaires privées. Le parlement a déjà tranché, mais pas encore le peuple.",
    {
      type: "Objet du Conseil fédéral",
      date: "22.3.2019",
      object: "18.035",
      vote: 18606
    }
  ],
  17280: [
    "Politique étrangère",
    "Le droit suisse est-il plus important que le droit international?",
    "Derrière cette énoncé se cache l’initiative populaire pour l'autodétermination. Un texte qui voulait que ce soit le droit suisse qui prime sur les traités internationaux. Une exigence séduisante, mais sournoise, dénonçaient alors ses opposants, pour qui la Suisse mettrait alors en péril sa sécurité du droit et ses accords avec les partenaires étrangers.",
    {
      type: "Objet du Conseil fédéral",
      date: "15.6.2018",
      object: "17.046",
      vote: 17280
    }
  ],
  17731: [
    "Assurances sociales",
    "Offrir des avantages fiscaux aux entreprises en échange d’un soutien de l’AVS, est-ce un bon compromis?",
    "On l’a souvent présenté comme le deal de l’année. Afin de faire passer la réforme fiscale des entreprises en votation, le Parlement l’a couplée avec un coup de pouce de 2 milliards pour le premier pilier. Malin. Ou scandaleux, comme avançaient ses détracteurs, pour qui lier deux objets qui n’ont pas grand-chose en commun revenait à prendre le peuple en otage.",
    {
      type: "Objet du Conseil fédéral",
      date: "28.9.2018",
      object: "18.031",
      vote: 17731
    }
  ],
  12895: [
    "Économie",
    "Faut-il étendre les horaires d’ouverture des magasins?",
    "Pour les partisans du projet, il s’agissait de mieux s’adapter aux nouvelles habitudes des consommateurs, mais aussi de rester concurrentiel face au tourisme d’achat. Les opposants dénonçaient une détérioration des conditions de vie pour les employés de la branche, alors qu’il existe suffisamment d’exceptions pour faire ses achats hors des horaires habituels.",
    {
      type: "Objet du Conseil fédéral",
      date: "29.2.2016",
      object: "14.095",
      vote: 12895
    }
  ],
  17566: [
    "Politique migratoire",
    "Faut-il expulser les terroristes vers leur pays d’origine, même s’ils risquent d’y mourir?",
    "Aujourd’hui, la Suisse renvoie les personnes qui portent atteinte à la sécurité de la Suisse dans leur pays, à moins que ce dernier ne soit pas sûr. Cette exception doit être levée, estimaient les partisans du texte, pour qui un terroriste ne mérite aucun égard. Cela reviendrait à les condamner à mort, et ce n’est pas le rôle d’un État de droit, retorquaient les opposants.",
    { type: "Motion", date: "19.9.2018", object: "16.3982", vote: 17566 }
  ],
  17761: [
    "Santé",
    "Les franchises de l’assurance maladie doivent-elles augmenter en même temps que l’évolution des coûts de la santé?",
    "Face à la hausse permanente des coûts de la santé, et donc des primes, toutes les solutions sont-elles acceptables? Pour une partie du Parlement, augmenter les franchises, était une piste à analyser pour renforcer la responsabilité individuelle et la prise de conscience des assurés. Le camps adverse dénonçait au contraire un projet inefficace mais surtout antisocial.",
    {
      type: "Objet du Conseil fédéral",
      date: "26.11.2018",
      object: "18.036",
      vote: 17761
    }
  ],
  18470: [
    "Suisse-UE",
    "La Suisse doit verser une contribution en faveur des États membres de l’UE?",
    "En pleine bisbille avec l’Union européenne, le milliard de cohésion a vite été pris en otage. Fallait-il le verser en guise de bonne volonté ou le retenir en guise de représailles. Pour faire passer la pilule, le parlement avait en tout cas décidé de choisir les domaines dans lesquels l’argent devrait être versé. Son sort n’a toujours pas été tranché.",
    {
      type: "Objet du Conseil fédéral",
      date: "18.3.2019",
      object: "18.068",
      vote: 18470
    }
  ],
  13197: [
    "Rôle de l’Etat",
    "Pour des raisons de sécurité, l’État a-t-il le droit de surveiller les communications des citoyens?",
    "Jusqu'où doit aller la protection de la sphère privée lorsqu’il s’agit de la sécurité de tous. Alors que l’Europe vivait plusieurs attentats tragiques, le projet visait à renforcer les moyens des services de renseignement pour fouiller les communications du citoyen. Nécessaire, selon ses partisans, intrusif selon ses opposants.",
    {
      type: "Objet du Conseil fédéral",
      date: "18.3.2016",
      object: "13.025",
      vote: 13197
    }
  ]
};

export default questions;
